import { install } from "ga-gtag";


const installGtag = () => {
  install("G-1K4PM1BEXM");
}

export default installGtag;